export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT'; 
export const GET_PROFILE = 'GET_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const ADD_LOADED_EXPS = 'ADD_LOADED_EXPS';
export const SET_LOADING_TRUE = 'SET_LOADING_TRUE';
export const REMOVE_ONE_EXP = 'REMOVE_ONE_EXP';
export const REMOVE_ONE_EXP_HOME = 'REMOVE_ONE_EXP_HOME';
export const ADD_ONE_EXP = 'ADD_ONE_EXP';
export const ADD_ONE_EXP_HOME = 'ADD_ONE_EXP_HOME';
export const GET_EXPS = 'GET_EXPS';
export const UPDATE_PROFILE_EXPS = 'UPDATE_PROFILE_EXPS';
export const HOMEPAGE_ERROR = 'HOMEPAGE_ERROR';
export const PAGE_ERROR = 'PAGE_ERROR';
export const CLEAR_PAGE = 'CLEAR_PAGE'; 
export const RESET_EXP_FEED = 'RESET_EXP_FEED';
export const OPEN_NEW_EXP = 'OPEN_NEW_EXP';
export const OPEN_EDIT_DETAILS = 'OPEN_EDIT_DETAILS';
export const GET_EXP_FEED = 'GET_EXP_FEED';
export const UPDATE_EXP_FEED = 'UPDATE_EXP_FEED';
export const GET_FOLLOWERS = 'GET_FOLLOWERS';
export const GET_FOLLOWING = 'GET_FOLLOWING';
export const CHANGE_PROF_PIC = 'CHANGE_PROF_PIC';
export const MAKE_FOLLOWING = 'MAKE_FOLLOWING';
export const MAKE_UNFOLLOWING = 'MAKE_UNFOLLOWING';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const GET_EDIT_EXP = 'GET_EDIT_EXP';
export const OPEN_EDIT_EXP = 'OPEN_EDIT_EXP';
export const CLOSE_EDIT_EXP = 'CLOSE_EDIT_EXP';
export const UPDATE_ONE_EXP_HOME = 'UPDATE_ONE_EXP_HOME';
export const UPDATE_ONE_EXP = 'UPDATE_ONE_EXP';
export const SHOW_NOTI_DROPDOWN = 'SHOW_NOTI_DROPDOWN';
export const ADD_NEW_NOTI = 'ADD_NEW_NOTI';
export const UPDATE_NOTI = 'UPDATE_NOTI';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const SET_SEARCH_RESULT = 'SET_SEARCH_RESULT';
export const CLOSE_SEARCH_RESULT = 'CLOSE_SEARCH_RESULT';
export const DELETE_NOTI = 'DELETE_NOTI';
export const GET_NOTI_COUNT = 'GET_NOTI_COUNT';

export const ADD_NOTI_ERROR = 'ADD_NOTI_ERROR';
export const GET_NOTIS = 'GET_NOTIS';
export const RESET_NOTIS = 'RESET_NOTIS';
export const REMOVE_NOTI_COUNT = 'REMOVE_NOTI_COUNT';
export const SET_END_OF_NOTIS = 'SET_END_OF_NOTIS';
